export default "__VITE_ASSET__CnS9kfJN__"